import { ActivityIndicator } from 'components/Shared/ActivityIndicator'
import { useAccessTokenContext } from 'contexts/AccessTokenContext'
import { useGetMe } from 'hooks/api/useGetMe'
import { useOutlet, Navigate, useLocation } from 'react-router-dom'
import {
  getLEPermissions,
  isPathAvailable,
} from 'src/navigation/pathPermissions'
import { useSnackbar } from 'stores/useSnackbar'
import { isPath } from './paths'
import { useCurrentCorporateAccountStore } from 'stores/useCurrentCorporateAccountStore'
import { useSetMe } from 'stores/useMeQuery'
import { useEffect } from 'react'

export const ProtectedLayout = () => {
  const location = useLocation()
  const leUserQuery = useGetMe()
  const { isPending, loginRequired } = useAccessTokenContext()
  const outlet = useOutlet()
  const setSnackbarMessage = useSnackbar((state) => state.setMessage)
  const caId = useCurrentCorporateAccountStore().currentCorporateAccountId
  const setPassedMe = useSetMe((state) => state.setPassedMe)

  useEffect(() => {
    setPassedMe(leUserQuery)
  }, [leUserQuery])

  if (loginRequired) {
    return <Navigate to="/" />
  }

  if (isPending || leUserQuery.isPending) {
    return <ActivityIndicator />
  }

  // Get the LE permissions
  const lePermissions = getLEPermissions(
    leUserQuery?.data?.licensedEstablishments,
    leUserQuery?.data?.user?.licensedEstablishments,
    caId
  )

  if (isPath(location.pathname)) {
    if (!isPathAvailable(location.pathname, lePermissions)) {
      return <Navigate to="/" replace />
    }
  } else {
    setSnackbarMessage('Forbidden', 'error')
    return <Navigate to="/" replace />
  }

  return outlet
}
